import { render, staticRenderFns } from "./professionalLicenses.vue?vue&type=template&id=0469f11e"
import script from "./professionalLicenses.vue?vue&type=script&lang=js"
export * from "./professionalLicenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports